import type { FunctionComponent } from 'react';
import { useState } from 'react';
import Tile from '@atlaskit/tile';
import { DEFAULT_SITE_AVATAR_URL } from '../../../definitions/avatar';

export interface SiteTileProps {
  avatarUrl?: string;
}

const SiteTile: FunctionComponent<SiteTileProps> = ({ avatarUrl }) => {
  const [useDefault, setUseDefault] = useState(false);
  const src = (avatarUrl && !useDefault) ? avatarUrl : DEFAULT_SITE_AVATAR_URL;

  return (
    <Tile label="" size="medium" isInset={false}>
      <img
        src={src}
        alt=""
        onError={() => setUseDefault(true)}
      />
    </Tile>
  );
};

export default SiteTile;
